import React from "react";
import { Link, Redirect } from "react-router-dom";
import usesFeatures from "usesFeatures"
import Loader from "Loader"
import Button from "Button"

import KitchenStation from "lib/auth/KitchenStation"
import FlashMessages from "FlashMessages"

// Chrome for the standalone KDS app. Mirrors TerminalLayout: the same webapp
// navbar (logo, separator, title) and button styling, but scoped to a single
// station with Grid/Recall nav and a Logout action in place of the terminal
// register controls.
class KDSLayout extends React.PureComponent {
  constructor (props) {
    super(props)
    const whoAmI = KitchenStation.getWhoAmI() || {}
    this.state = { station: whoAmI.station, venueName: whoAmI.venueName }
  }

  componentDidMount() {
    // Refetch when the venue name is missing too, so devices with a whoami
    // cached before venueName existed pick it up without re-logging in.
    if (!this.state.station || !this.state.venueName) {
      this.props.fetchData("kds/whoami", this.cacheWhoAmI)
    }
  }

  cacheWhoAmI = (data) => {
    KitchenStation.setWhoAmI(data)
    this.setState({ station: data.station, venueName: data.venueName })
  }

  // All nav buttons share one look; the active one is filled (is-info).
  navClass = (active) => `button mr-2 ${active ? "is-info" : ""}`

  handleLogout = () => {
    KitchenStation.clearAuthToken()
    KitchenStation.clearWhoAmI()
    this.setState({ loggedOut: true })
  }

  render() {
    if (this.state.loggedOut) return <Redirect to="/login" />
    if (!this.props.dataFetched && !this.state.station) return false

    const { station, venueName } = this.state
    const path = window.location.pathname
    const onRecall = path.startsWith("/recall")
    const onSettings = path.startsWith("/settings")
    const onGrid = !onRecall && !onSettings
    const subtitle = [venueName, station && station.name].filter(Boolean).join(" · ")

    return(
      <div className="KDSLayout">
        <FlashMessages />
        <div className="webapp-navbar no-print">
          <div className="webapp-navbar-inner">
            <div className="left">
              <a href="/" className="brand">
                <img className="light-image" src="/images/stupid-logo.svg" alt="" />
              </a>
              <div className="separator"></div>
              <h1 id="webapp-page-title" className="title is-5" style={{ whiteSpace: "nowrap" }}>
                Kitchen Display
                <br/>
                <small className="subtitle is-size-6 text-no-wrap">{ subtitle }</small>
              </h1>
            </div>
            <div className="center"></div>
            <div className="right">
              <div className="navbar-item">
                <div className="buttons">
                  <Link to="/" className={this.navClass(onGrid)}>Grid</Link>
                  <Link to="/recall" className={this.navClass(onRecall)}>Recall</Link>
                  <Link to="/settings" className={this.navClass(onSettings)}>Settings</Link>
                  <Button
                    className="button is-outlined is-danger ml-6"
                    onClick={this.handleLogout}
                    text="Logout"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="view-wrapper is-webapp">
          <div className="page-content-wrapper">
            <div className="page-content is-relative">
              { station ? this.props.children : <Loader /> }
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default usesFeatures(['data'], KDSLayout)
